exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.select2-container--default .select2-selection--single {\n    border: 1px solid #c9ccd0 !important;\n    border-radius: 0px !important;\n\theight: 30px !important;\n}\n.select2-container--default.select2-container--focus .select2-selection--single, .select2-container--default.select2-container--open.select2-container--below .select2-selection--single {\n\tborder-color: #495966!important;\n}\n.select2-results__option {\n    font-size: 11px !important;\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n    background-color: #1ab394;\n}\n", ""]);

// exports
